// Externals
import { createAction } from '@reduxjs/toolkit';

// Actions
export const changeNavigation = createAction('CHANGE_NAVIGATION');
